import React, { useMemo } from "react";
import useCustomRef from "hooks/useCustomRef";
import { Controller, useFormContext } from "react-hook-form";
import { inputNumericoEnteros } from "../formas/validaciones";
import NumberFormat from "react-number-format";
import classNames from "classnames";
import { Button } from "primereact/button";
import SimpleErrorMessage from "components/InputsMex/containers/SimpleErrorMessage";
import { AutoComplete } from "primereact/autocomplete";
import { Dropdown } from "primereact/dropdown";
import Select from "react-select";

import es from "date-fns/locale/es";
import DatePicker, { registerLocale } from "react-datepicker";
import styled from "styled-components";
import COLORS from "utils/constants/COLORS";

export const SimpleWrapper = ({
  children,
  label,
  subLabel = null,
  name,
  info = null,
  extrasClasses,
}) => {
  const { formState, errors } = useFormContext();
  let hasError = Object.byString(errors, name) !== undefined;
  let showCheck = false;
  if (formState.dirtyFields[name]) {
    showCheck = !hasError;
  }
  return (
    <React.Fragment>
      <div className={"container-accidentes w-100" + extrasClasses}>
        <label
          className='accidentes text-left'
          htmlFor={name}
          style={{ fontSize: "20px" }}>
          {label} {showCheck && <div className='img-input-active '>&nbsp;</div>}
          {info !== null && (
            <Button
              type='button'
              style={{ borderRadius: "25%" }}
              className='p-button-text p-button-plain p-0 pl-1 font-20px'
              tooltip={info ?? ""}>
              <i className='pi pi-question-circle' style={{ fontSize: "1rem" }} />
            </Button>
          )}
        </label>
        <div className='container-input-accidentes'>
          <div className='row'>
            <div
              className={classNames({
                "my-2": true,
                "col-10": subLabel !== null,
                "col-12": !subLabel,
              })}>
              {children}
            </div>
            {subLabel && (
              <div className='col-2 mt-2'>
                <div className='placeholder-full-input-type1 mt-2 mb-2'>{subLabel}</div>
              </div>
            )}
          </div>
          {Object.byString(errors, name) && (
            <div className='container col-12'>
              <strong className='error-msg-lf '>
                {Object.byString(errors, name).message}
              </strong>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export const TextInput = ({
  rules,
  inputProps,
  extrasClasses,
  allowNegative = false,
  isUpper = false,
  hideArrows = false,
  defaultValue = null,
  sufijo = "",
  prefijo = "",
  disabled = false,
  onChangeFn = () => {},
  numerico = false,
  thousandSeparator = true,
  decimalScale = 2,
}) => {
  const { register, control } = useFormContext();
  const { focusRef } = useCustomRef(null);

  const memoProps = useMemo(() => {
    if (inputProps.isNumberInt) {
      const newInputProps = {
        ...inputProps,
        type: "number",
        onKeyDown: inputNumericoEnteros,
      };
      delete newInputProps.isNumberInt;

      return newInputProps;
    }
    return inputProps;
  }, [inputProps]);

  return (
    <Controller
      control={control}
      name={inputProps.name}
      rules={rules}
      defaultValue={defaultValue}
      onFocus={focusRef}
      render={({ onChange, value, ref }) => {
        return (
          <React.Fragment>
            {numerico && (
              <NumberFormat
                defaultValue={defaultValue}
                allowNegative={allowNegative}
                suffix={sufijo}
                prefix={prefijo}
                thousandSeparator={thousandSeparator}
                decimalScale={decimalScale}
                readOnly={disabled}
                onValueChange={(v) => {
                  onChange(v.value !== "" ? v.value * 1 : null);
                  onChangeFn(v.value !== "" ? v.value * 1 : null);
                }}
                value={value !== null && value !== undefined ? value * 1 : ""}
                className={`w-100 border-0 input-line-heigth-cero input-home-cotizacion-type1bold ${extrasClasses}`}
              />
            )}
            {!numerico && (
              <input
                id={inputProps.name}
                readOnly={disabled}
                className={classNames({
                  [`input-line-heigth-cero input-home-cotizacion-type1bold ${extrasClasses}`]: true,
                  "hide-arrows": hideArrows,
                })}
                ref={register(rules)}
                {...memoProps}
                defaultValue={defaultValue}
                onChange={(e) => {
                  if (isUpper) {
                    onChange(e.target.value.toUpperCase());
                    onChangeFn(e.target.value.toUpperCase());
                  } else {
                    onChange(e.target.value);
                    onChangeFn(e.target.value);
                  }
                }}
                //ref={(ref) => console.log('REF: ', ref)}
              />
            )}
          </React.Fragment>
        );
      }}
    />
  );
};

export const SimpleCheckBox = ({
  name,
  label,
  rules = {},
  defaultValue = false,
  id,
  type = "normal",
}) => {
  return (
    <div className={"row"}>
      <Controller
        name={name}
        defaultValue={defaultValue}
        rules={rules}
        render={({ value, onChange }) => (
          <div className='col-1' style={{ marginRight: "-1em" }}>
            <input
              type='checkbox'
              id={id}
              className='chek-terminos'
              checked={value}
              onChange={(evt) => {
                onChange(evt.target.checked);
              }}
            />
            {type === "slide" && <label for={name} className='check-type-slide'></label>}
          </div>
        )}
      />
      <div className='col-11'>
        <label for={name} className='disclaimers-auto'>
          {label}
          <br></br>
          <SimpleErrorMessage name={name} />
        </label>
      </div>
    </div>
  );
};

//Check box for Pymes
export const SimpleCheckBoxB = ({
  name,
  label,
  rules = {},
  defaultValue = false,
  id,
  type = "normal",
  fontSize = "1em",
  disabled = false,
}) => {
  return (
    <div className='d-flex'>
      <Controller
        name={name}
        defaultValue={defaultValue}
        rules={rules}
        render={({ value, onChange }) => (
          <div className='my-auto containerCheckH '>
            <input
              type='checkbox'
              id={id}
              className='chek-terminos my-auto mr-2'
              disabled={disabled}
              checked={value}
              onChange={(evt) => {
                onChange(evt.target.checked);
              }}
            />
            {type === "slide" && <label htmlFor={name} className=' checkmarkH '></label>}
          </div>
        )}
      />
      <div className='d-flex'>
        <label
          htmlFor={name}
          // className="disclaimers-auto"
          className='my-auto checkmarkH'
          style={{ fontSize }}>
          {label}
          <br></br>
          <SimpleErrorMessage name={name} />
        </label>
      </div>
    </div>
  );
};

export const SimpleCheckBoxA = ({
  name,
  label,
  rules = {},
  defaultValue = false,
  id,
  type = "normal",
  fontSize = "1em",
  disabled = false,
  onClick = () => {},
}) => {
  return (
    <div className='d-flex'>
      <Controller
        name={name}
        defaultValue={defaultValue}
        rules={rules}
        render={({ value, onChange }) => (
          <label className='containerCheckH '>
            {label}
            <input
              type='checkbox'
              checked={value}
              onChange={(evt) => {
                onChange(evt.target.checked);
                evt.target.checked && onClick();
              }}
            />
            <span className='checkmarkH'></span>
          </label>
        )}
      />
    </div>
  );
};

export const SeleccionarFecha = ({
  name = "",
  rules,
  fechaInicio,
  fechaFin,
  placeholder,
  preload = null,
  dateFormat = "EEEE, dd 'de' MMMM 'del' yyyy",
}) => {
  const { control } = useFormContext();
  registerLocale("es", es);

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ onChange, value = preload }) => {
          return (
            <React.Fragment>
              <DatePicker
                locale='es'
                selected={value}
                onChange={(date) => onChange(date)}
                minDate={new Date(fechaInicio)}
                maxDate={new Date(fechaFin)}
                placeholderText={placeholder}
                className='picker'
                isClearable
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode='select'
                onChangeRaw={(e) => {
                  e.preventDefault();
                }}
                dateFormat={dateFormat}
              />
            </React.Fragment>
          );
        }}
      />
    </React.Fragment>
  );
};

export const Autocompletar = ({
  name,
  rules,
  type = "number",
  minLength = 1,
  maxLength = 10,
  completeMethod = () => {},
  suggestions = [],
  onSelectCodPostal = () => {},
  onUnselect = () => {},
  onChangeFn,
  dataKey,
  loading,
  disabled = false,
  defaultValue = null,
  placeholder = "SELECCIONE",
  loadingText = "BUSCANDO...",
  helpText,
  filter = true,
  emptyFilterMessage = "NO SE HA ENCONTRADO INFORMACIÓN",
  showClear = true,
  ...props
}) => {
  const { control } = useFormContext();

  const internalPlaceHolder = useMemo(
    () => (loading ? loadingText : placeholder),
    [loading, placeholder, loadingText]
  );

  const { focusRef, setRef } = useCustomRef(null);

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        onFocus={focusRef}
        render={({ onChange, value, ref }) => {
          return (
            <AutoComplete
              showClear={showClear}
              minLength={minLength}
              maxlength={maxLength}
              forceSelection={true}
              onSelect={onSelectCodPostal}
              className='input__mask__mex'
              inputId={name}
              completeMethod={completeMethod}
              suggestions={suggestions}
              dataKey={dataKey}
              placeholder={internalPlaceHolder}
              disabled={loading || disabled}
              value={value ? value : ""}
              helpText={helpText}
              style={{ width: "100%" }}
              ref={setRef("focusInput")}
              emptyFilterMessage={emptyFilterMessage}
              onChange={(evt) => {
                onChange(evt.value);
                onChangeFn && onChangeFn(evt.value);
              }}
              onBlur={onUnselect}
              //panelStyle={{ overFlow: 'hidden' }}
            />
          );
        }}
      />
    </React.Fragment>
  );
};

export const DropDownFilterX = ({
  name,
  rules,
  showClear = true,
  onSelect = () => {},
  optionLabel = "label",
  optionValue = "value",
  options = [],
  onChangeFn = () => {},
  dataKey,
  loading,
  disabled = false,
  defaultValue = null,
  placeholder = "SELECCIONE",
  loadingText = "BUSCANDO...",
  helpText,
  filter = true,
  emptyFilterMessage = "NO SE HA ENCONTRADO INFORMACIÓN",
  ...props
}) => {
  const { control } = useFormContext();

  const internalPlaceHolder = useMemo(
    () => (loading ? loadingText : placeholder),
    [loading, placeholder, loadingText]
  );

  const { focusRef } = useCustomRef(null);

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        onFocus={focusRef}
        render={({ onChange, value, ref }) => {
          return (
            <Dropdown
              className='input__mask__mex'
              inputId={name}
              //showFilterClear={showClear}
              showClear={showClear}
              filterInputAutoFocus={false}
              optionLabel={optionLabel}
              optionValue={optionValue}
              options={options}
              filter={options.length > 6}
              dataKey={dataKey}
              placeholder={internalPlaceHolder}
              disabled={loading || disabled}
              value={value ? value : ""}
              helpText={helpText}
              style={{ width: "100%" }}
              //ref={setRef("focusInput")}
              ref={ref}
              emptyFilterMessage={emptyFilterMessage}
              onChange={(evt) => {
                onChange(evt.value ? evt.value : "");
                onChangeFn && onChangeFn(evt.value ? evt.value : "");
                onSelect(evt.value ? evt.value : "");
                //onSelect();
              }}

              //panelStyle={{ overFlow: 'hidden' }}
            />
          );
        }}
      />
    </React.Fragment>
  );
};

const customStylesDropDown = {
  menu: (provided, state) => ({
    ...provided,
    color: state.selectProps.menuColor,
    marginLeft: "-1em",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    fontWeigth: "bold",
    color: "#6c757d",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    fontWeigth: "bold",
  }),
  option: (styles, { data, isDisabled, isSelected }) => {
    const color = "#001871";
    return {
      ...styles,
      ":active": {
        ...styles[":active"],
        backgroundColor: !isDisabled && (isSelected ? data.color : color),
        color: "white",
      },
    };
  },
};

/**
 * @description Este componente de <Select/> no es sencible al undefined, no le toma como null
 * @param {*} param0
 * @returns
 */

export const DropDownFilter = ({
  name,
  rules,
  onSelect = () => {},
  optionLabel = "label",
  optionValue = "value",
  options = [],
  onChangeFn,
  dataKey,
  loading,
  disabled = false,
  defaultValue = null,
  placeholder = "SELECCIONE",
  loadingText = "BUSCANDO...",
  helpText,
  filter = true,
  emptyFilterMessage = "NO SE HA ENCONTRADO INFORMACIÓN",
  value,
  ...props
}) => {
  const { control } = useFormContext();
  const objectPath = require("object-path");

  const opciones = options?.map((option) => ({
    label: objectPath.get(option, optionLabel),
    value: objectPath.get(option, optionValue),
  }));

  const { setRef } = useCustomRef(null);

  const internalPlaceHolder = useMemo(
    () => (loading ? loadingText : placeholder),
    [loading, placeholder, loadingText]
  );

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ onChange, value, ref }) => {
          const label = opciones?.find(
            (item) => JSON.stringify(item?.value) === JSON.stringify(value)
          )?.label;
          let normalizado = {
            label,
            value,
          };

          let esValido = normalizado.label && normalizado.value;

          if (!esValido && !!defaultValue) {
            normalizado = {
              label: defaultValue.label,
              value: defaultValue,
            };
            esValido = true;
          }

          return (
            <React.Fragment>
              <Select
                className='w-100'
                id={name}
                defaultValue={defaultValue}
                isClearable={true}
                isSearchable={true}
                isDisabled={loading || disabled}
                isLoading={loading}
                noOptionsMessage={() => emptyFilterMessage}
                loadingMessage={() => {
                  return "Buscando...";
                }}
                value={esValido ? normalizado : internalPlaceHolder}
                name={name}
                options={opciones}
                ref={setRef("select")}
                onChange={(evt) => {
                  if (evt) {
                    onChange(evt?.value);
                    onChangeFn && onChangeFn(evt?.value);
                    onChangeFn && onChangeFn(evt.value ? evt.value : "");
                    onSelect(evt.value ? evt.value : "");
                  } else {
                    onChange(null);
                    onChangeFn && onChangeFn(null);
                  }
                }}
                placeholder={internalPlaceHolder}
                styles={customStylesDropDown}
              />
            </React.Fragment>
          );
        }}
      />
    </React.Fragment>
  );
};

export const BaseButton = styled.button`
  border: none;
  outline: none;
  width: 100%;
  color: ${(props) => props.textColor || COLORS.primary};
  background-color: ${(props) => props.bgColor || "white"};
  height: 60px;
  font-size: 20px;
  text-transform: uppercase;
  cursor: pointer;
  font-family: "Futura-Medium", Arial, Helvetica, sans-serif;
`;
